<template>
  <iframe :id="$attrs['id']"
          :srcdoc="emailContent"
          width="100%"
          height="100%"
          scrolling="no"
          style="flex-grow: 1;overflow: auto;">

  </iframe>
</template>

<script>

import { isNil } from 'lodash';
import TimerMixin from '../../../mixins/TimerMixin';

export default {
  name: 'EditableIframe',

  mixins: [TimerMixin],

  props: {
    url: String,
    params: Object,
  },

  data() {
    return {
      srcdoc: '',
    };
  },

  mounted: function () {
    const iframe = this.$el;

    iframe.onload = this.waitForVisible;
  },

  created: function () {
  },

  methods: {
    getContent: function () {
      return this.$el.contentWindow.document.documentElement.outerHTML;
    },
    waitForVisible: function () {
      const iframe = this.$el;

      if (iframe.offsetParent !== null) {
        iframe.height = `${iframe.contentWindow.document.body.offsetHeight}rem`;
      } else {
        this.setTimeout(this.waitForVisible, 200);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';

</style>



// WEBPACK FOOTER //
// src/components/lib/util/EditableIframe.vue